const infoFieldSearchParamGen = (infofields) => {
  const allFields = Object.entries(infofields);
  const searchFields = {};

  allFields.forEach((field, idx) => {
    searchFields[idx] = field;
  });

  return searchFields;
};

export default infoFieldSearchParamGen;
